// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: rbPHTCCgxa1NtQh9SvuYvu
// Component: oRvUkHBF3bcFzv
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_library_plasmic_color_type_css from "../library_plasmic_color_type/plasmic_library_plasmic_color_type.module.css"; // plasmic-import: seaQhLVS4bbjiGvJJrRwyL/projectcss
import projectcss from "./plasmic_furn_e_commerce.module.css"; // plasmic-import: rbPHTCCgxa1NtQh9SvuYvu/projectcss
import sty from "./PlasmicRatings.module.css"; // plasmic-import: oRvUkHBF3bcFzv/css
import StarIcon from "./icons/PlasmicIcon__Star"; // plasmic-import: HXpCUfDkgRXoAZ/icon

export const PlasmicRatings__VariantProps = new Array("stars");

export const PlasmicRatings__ArgProps = new Array("numReviews");

function PlasmicRatings__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = args;
  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_library_plasmic_color_type_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootstars_five]: hasVariant(variants, "stars", "five"),
          [sty.rootstars_four]: hasVariant(variants, "stars", "four"),
          [sty.rootstars_one]: hasVariant(variants, "stars", "one"),
          [sty.rootstars_three]: hasVariant(variants, "stars", "three"),
          [sty.rootstars_two]: hasVariant(variants, "stars", "two"),
          [sty.rootstars_zero]: hasVariant(variants, "stars", "zero")
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        {(hasVariant(variants, "stars", "zero") ? true : true) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg___9I4Vp, {
              [sty.svgstars_five___9I4VpXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_zero___9I4VPdj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : hasVariant(variants, "stars", "one")
            ? true
            : hasVariant(variants, "stars", "zero")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__cWgr1, {
              [sty.svgstars_five__cWgr1XyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__cWgr18FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_one__cWgr1W0Qci]: hasVariant(
                variants,
                "stars",
                "one"
              ),

              [sty.svgstars_three__cWgr1KUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__cWgr1DV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              ),

              [sty.svgstars_zero__cWgr1Dj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : hasVariant(variants, "stars", "one")
            ? true
            : hasVariant(variants, "stars", "zero")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__omYag, {
              [sty.svgstars_five__omYagXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__omYag8FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_one__omYagW0Qci]: hasVariant(
                variants,
                "stars",
                "one"
              ),

              [sty.svgstars_three__omYagKUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__omYagdV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              ),

              [sty.svgstars_zero__omYagdj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : hasVariant(variants, "stars", "one")
            ? true
            : hasVariant(variants, "stars", "zero")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__inhlL, {
              [sty.svgstars_five__inhlLXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__inhlL8FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_one__inhlLw0Qci]: hasVariant(
                variants,
                "stars",
                "one"
              ),

              [sty.svgstars_three__inhlLkUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__inhlLdV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              ),

              [sty.svgstars_zero__inhlLdj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : hasVariant(variants, "stars", "one")
            ? true
            : hasVariant(variants, "stars", "zero")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__kp946, {
              [sty.svgstars_five__kp946XyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__kp9468FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_one__kp946W0Qci]: hasVariant(
                variants,
                "stars",
                "one"
              ),

              [sty.svgstars_three__kp946KUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__kp946DV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              ),

              [sty.svgstars_zero__kp946Dj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : hasVariant(variants, "stars", "one")
            ? true
            : hasVariant(variants, "stars", "zero")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__czqLe, {
              [sty.svgstars_five__czqLeXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__czqLe8FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_one__czqLeW0Qci]: hasVariant(
                variants,
                "stars",
                "one"
              ),

              [sty.svgstars_three__czqLeKUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__czqLedV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              ),

              [sty.svgstars_zero__czqLedj5Ab]: hasVariant(
                variants,
                "stars",
                "zero"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : hasVariant(variants, "stars", "two")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__db2J7, {
              [sty.svgstars_five__db2J7XyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__db2J78FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_three__db2J7KUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              ),

              [sty.svgstars_two__db2J7DV2M8]: hasVariant(
                variants,
                "stars",
                "two"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : hasVariant(variants, "stars", "three")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg___1Wuzd, {
              [sty.svgstars_five___1WuzdXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four___1Wuzd8FoN]: hasVariant(
                variants,
                "stars",
                "four"
              ),

              [sty.svgstars_three___1WuzdKUy8O]: hasVariant(
                variants,
                "stars",
                "three"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(
          hasVariant(variants, "stars", "five")
            ? true
            : hasVariant(variants, "stars", "four")
            ? true
            : true
        ) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg__eD10V, {
              [sty.svgstars_five__eD10VXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              ),

              [sty.svgstars_four__eD10V8FoN]: hasVariant(
                variants,
                "stars",
                "four"
              )
            })}
            role={"img"}
          />
        ) : null}

        {(hasVariant(variants, "stars", "five") ? true : true) ? (
          <StarIcon
            className={classNames(projectcss.all, sty.svg___4G5Wl, {
              [sty.svgstars_five___4G5WlXyUj]: hasVariant(
                variants,
                "stars",
                "five"
              )
            })}
            role={"img"}
          />
        ) : null}
      </p.Stack>

      {p.renderPlasmicSlot({
        defaultContents: "(45 Review)",
        value: args.numReviews,
        className: classNames(sty.slotTargetNumReviews)
      })}
    </p.Stack>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicRatings__ArgProps,
          internalVariantPropNames: PlasmicRatings__VariantProps
        }),

      [props, nodeName]
    );

    return PlasmicRatings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRatings";
  } else {
    func.displayName = `PlasmicRatings.${nodeName}`;
  }
  return func;
}

export const PlasmicRatings = Object.assign(
  // Top-level PlasmicRatings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicRatings
    internalVariantProps: PlasmicRatings__VariantProps,
    internalArgProps: PlasmicRatings__ArgProps
  }
);

export default PlasmicRatings;
/* prettier-ignore-end */
